export const ACTION_TYPES = {
  GET_LIST_PACKAGE: Symbol("GET_LIST_PACKAGE"),
  SET_LIST_PACKAGE: Symbol("SET_LIST_PACKAGE"),
};
